import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom'
import swal from 'sweetalert';
import { Select } from 'antd';
import 'antd/dist/antd.css';
import moment from 'moment';
import axios from 'axios';
import api from '../../config.json'
import validation from '../../utill/validation';
import Joi from 'joi';
import Loading from '../../utill/LoadingComponent';
const CustomField = ({ history ,Heading}) => {
    const location = useLocation()
    const [listNames, setAllListNames] = useState([]);
    const [errors, setErrors] = useState({})
    const [loader, setLoader] = useState(false);
    const [formData, setFormData] = useState({});

    const dataTypes = [
        { label: "String", value: 'string' },
        { label: "Number", value: 'number' },
        { label: "Float", value: 'float' },
        { label: "Date", value: 'date' },
        { label: "Time", value: 'time' },
        { label: "List", value: 'list' }
    ]

    useEffect(() => {
        if (location.state && location.state.action == 'edit') {
            setFormData(location.state.data);
        }
    }, [location])

    useEffect(() => {
        Heading('Custom Filed Master')
        getAllListNames()
    }, [])

    const schema = {
        Specification: Joi.optional().label('List Name'),
        FieldName: Joi.required().label('Field Name'),
        DataType: Joi.required().label('Data Type'),
        _id: Joi.string()
    }


    const handleOnChange = (e) => {
        const obj = { ...formData }
        const { name, value } = e.currentTarget;
        obj[name] = value;
        const error = validation.validateProperty(e.currentTarget, schema);
        setErrors(error || {})
        setFormData(obj);
        console.log(obj);
    }

    const getAllListNames = () => {
        axios.get(api.api + "ListMaster")
            .then((result) => {
                const all = result.data.map((one) => { return { label: one.ListName, value: one.ListName } })
                setAllListNames(all)
            })
            .catch((err) => {
                console.log(err, "Error")
            })
    }


    const handleSave = () => {
        delete formData.__v
        delete formData.createdAt
        delete formData.updatedAt
        const error = validation.validate(formData, schema)
        if (error) {
            setErrors(error)
            return
        }
        setErrors(error || {})
        setLoader(true)
        if (location.state && location.state.action == "edit") {
            if (formData.DataType !== 'list') {
                delete formData.Specification
            }
            axios.patch(api.api + 'CustomField/' + formData._id, formData)
                .then((result) => {
                    swal('Update Successfully');
                    history.push('/setting/customfield/list');
                    setLoader(false)
                })
                .catch((err) => {
                    if (err.response && err.response.data) {
                        swal(err.response.data.message, { dangerMode: true })
                    } else {
                        swal(`${err}`);
                    }

                    setLoader(false)
                })
        } else {
            axios.post(api.api + 'CustomField', formData)
                .then((result) => {
                    swal('Save Successfully');
                    history.push('/setting/customfield/list');
                    setLoader(false)
                })
                .catch((err) => {
                    if (err.response && err.response.data) {
                        swal(err.response.data.message, { dangerMode: true })
                    } else {
                        swal(`${err}`);
                    }
                    setLoader(false)
                })
        }
    }

    return (
        <React.Fragment>
            {loader ? <Loading labelShow={true} label={"Loading..."} /> : ''}
            {/* <div className='text-center' >
                <p >Custom Fields Form</p>
            </div> */}
            {/* <ToastContainer /> */}

            <div className="row">
                <div className="col-sm-4">
                    <div className="form-group text-center">
                        <label className='small'>Field Name</label>
                        <input name='FieldName' value={formData.FieldName} className='form-control form-control-sm' onChange={handleOnChange} type='text' placeholder='Enter field name..' />

                    </div>
                    {errors.FieldName && <div className="alert small alert-danger">{errors['FieldName']}</div>}
                </div>
                <div className='col-sm-4 mt-2 text-center'>
                    <label className='small'>Data Type</label>
                    <Select
                        // maxTagCount='responsive'
                        //mode="multiple"
                        placeholder="Select Data Type"
                        value={formData.DataType}
                        onChange={(values) => {
                            handleOnChange({ currentTarget: { name: 'DataType', value: values } })
                        }}
                        style={{ width: '100%' }}
                        options={dataTypes}
                    />
                    {errors.DataType && <div className="alert small alert-danger">{errors['DataType']}</div>}
                </div>
                {formData.DataType == "list" && <div className='col-sm-4 mt-2 text-center'>
                    <label className='small'>Specification( For List )</label>
                    <Select
                        placeholder="Select List Name"
                        value={formData.Specification}
                        onChange={(values) => {
                            handleOnChange({ currentTarget: { name: 'Specification', value: values } })
                        }}
                        style={{ width: '100%' }}
                        options={listNames}
                    />
                    {errors.Specification && <div className="alert small alert-danger">{errors['Specification']}</div>}
                </div>}

            </div>
            <div className='row text-center mt-2'>
                <div className='col-sm-12'>
                    <button onClick={handleSave} className="btn-sm btn-primary">Submit</button>
                    <button onClick={() => history.push('/setting/customfield/list')} className="btn-sm btn-primary ml-4">Cancel</button>
                </div>
            </div>

            {/* {qualityData.length > 0 && <Table
                id="RejectionDetailedAnalysispiechart"
                // onSort={handleSort}
                columns={columns1}
                sortColumn={sortColumn}
                data={extractInspectionDataSeparateArray(qualityData[0])}
            />} */}

        </React.Fragment>
    );
}
export default CustomField;